<template>
  <v-layout class="restaurant-settings-container">
    <v-container fluid>
      <v-card>
        <v-card-title>
          <span>{{
            !onlyBranch ? $t('storeSettings.title') : $t('branchSettings.title')
          }}</span>
        </v-card-title>
        <v-card-text v-if="editingRestaurant || (onlyBranch && editingBranch)">
          <v-tabs v-model="tabIndex">
            <v-tab href="#basic"
              >{{ $t('storeSettings.basicOptions') }}
              <v-icon v-if="!basicValid" color="red" class="ml-1"
                >mdi-alert-circle</v-icon
              ></v-tab
            >
            <v-tab href="#info"
              >{{ $t('storeSettings.additionalInfo') }}
              <v-icon v-if="!infoValid" color="red" class="ml-1"
                >mdi-alert-circle</v-icon
              ></v-tab
            >
            <v-tab href="#orders" v-if="effectiveTier > 0"
              >{{ $t('orders') }}
              <v-icon v-if="!ordersValid" color="red" class="ml-1"
                >mdi-alert-circle</v-icon
              ></v-tab
            >
            <v-tab href="#plan" v-if="!onlyBranch">
              <span class="pr-2">{{ $t('storeSettings.plan') }}</span>
              <v-chip
                style="cursor: pointer"
                v-if="isPlanExpired"
                label
                x-small
                color="red"
                text-color="white"
                >Vencido</v-chip
              >
              <v-chip
                style="cursor: pointer"
                v-else-if="effectiveTier === 0"
                label
                x-small
                color="green"
                text-color="white"
                >Lite</v-chip
              >
              <v-chip
                style="cursor: pointer"
                v-else-if="effectiveTier === 1"
                label
                x-small
                color="orange"
                text-color="white"
                >Plus</v-chip
              >
              <v-chip
                style="cursor: pointer"
                v-else-if="effectiveTier === 2"
                label
                x-small
                color="#ff6f00"
                text-color="white"
                >Pro</v-chip
              >
            </v-tab>
            <v-tab href="#plan" v-if="effectiveTier === 0">
              <span class="pr-2">{{ $t('orders') }}</span>
              <v-chip
                style="cursor: pointer"
                label
                x-small
                color="orange"
                text-color="white"
                >Plus</v-chip
              >
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabIndex">
            <v-tab-item eager class="basic-settings" value="basic">
              <v-form @submit.prevent v-model="basicValid">
                <v-row>
                  <v-col cols="12" lg="6" v-if="!onlyBranch">
                    <h3>Información básica</h3>
                    <v-row>
                      <v-col class="text-center">
                        <h4>{{ $t('logo') }}</h4>
                        <single-image-uploader
                          class="logo-uploader"
                          v-model="editingRestaurant.logo"
                        ></single-image-uploader>
                      </v-col>
                      <v-col class="text-center">
                        <h4>{{ $t('storeSettings.banner') }}</h4>
                        <single-image-uploader
                          class="banner-uploader"
                          v-model="editingRestaurant.banner"
                        ></single-image-uploader>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-text-field
                              :label="$t('name')"
                              v-model="editingRestaurant.name"
                              :rules="$rule('required|min4')"
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              :label="$t('identifier')"
                              class="mb-3"
                              v-model="editingRestaurant.stringId"
                              :rules="$rule('required|min3|username')"
                              :persistent-hint="true"
                              :hint="
                                $t('storeSettings.identifier.hint', {
                                  id: editingRestaurant.stringId || 'id',
                                })
                              "
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-select
                              :label="$t('country')"
                              outlined
                              dense
                              v-model="editingRestaurant.country"
                              disabled
                              :rules="$rule('required')"
                              :items="countries"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-select
                              :label="$t('currency')"
                              outlined
                              dense
                              v-model="editingRestaurant.currency"
                              :rules="$rule('required')"
                              :items="currencies"
                            ></v-select>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <template v-if="settings">
                      <v-row>
                        <v-col cols="12" sm="6">
                          <h3>Impuestos o recargo</h3>
                          <p class="mb-1">
                            Puede añadir impuestos o recargos al precio de los
                            productos, o al total del pedido (en el caso de
                            aceptar pedidos)
                          </p>
                          <v-radio-group
                            class="mt-0 mb-2"
                            v-model="settings.taxMode"
                            hide-details
                          >
                            <v-radio
                              label="Sin impuestos o ya incluido en el precio"
                              :value="0"
                            />
                            <v-radio
                              label="Añadir impuestos a los precios"
                              :value="1"
                            />
                            <v-radio
                              label="Añadir impuestos a los precios y aclarar en la descripción"
                              :value="2"
                            />
                            <v-radio
                              label="Sumar impuestos al finalizar el pedido"
                              :value="3"
                            />
                          </v-radio-group>
                          <v-row v-if="settings.taxMode > 0">
                            <v-col cols="12" sm="6" class="pb-0">
                              <v-text-field
                                v-model="editingRestaurant.taxName"
                                label="Nombre corto del impuesto"
                                hint="Por ejemplo: IVA, Impuesto, ITBMS..."
                                persistent-hint
                                :rules="$rule('required|min3|max16')"
                                outlined
                                dense
                              />
                            </v-col>
                            <v-col cols="12" sm="6" class="pb-0">
                              <v-text-field
                                v-model="editingRestaurant.tax"
                                label="Valor del impuesto"
                                prefix="%"
                                hint="Porcentaje a adicionar"
                                persistent-hint
                                type="number"
                                :rules="$rule('required|allnumber')"
                                outlined
                                dense
                              />
                            </v-col>
                          </v-row>
                          <v-checkbox
                            v-if="settings.taxMode > 0"
                            label="Sumar impuesto al costo de envío"
                            hint="Active esta opción para añadir el impuesto al costo de envío, si lo hubiera"
                            persistent-hint
                            class="mt-0"
                            v-model="settings.taxDelivery"
                          />
                        </v-col>
                        <v-col cols="12" sm="6">
                          <h3>Redondeo</h3>
                          <p class="mb-1">
                            ¿Desea redondear el total del pedido? (ignore si no
                            utiliza pedidos)
                          </p>
                          <v-radio-group
                            class="mt-0 mb-2"
                            v-model="settings.roundMode"
                            hide-details
                          >
                            <v-radio label="No redondear" :value="0" />
                            <v-radio
                              label="Redondear al mas cercano"
                              :value="1"
                            />
                            <v-radio label="Redondear para abajo" :value="2" />
                            <v-radio label="Redondear para arriba" :value="3" />
                          </v-radio-group>
                          <v-row v-if="settings.roundMode > 0">
                            <v-col cols="12" sm="6" class="pb-0">
                              <v-text-field
                                v-model="settings.roundInterval"
                                label="Intervalo"
                                :prefix="currency.symbol"
                                hint="Si no está seguro, ingrese 1"
                                persistent-hint
                                type="number"
                                :rules="$rule('required|number')"
                                outlined
                                dense
                              />
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="
                          effectiveTier > 0 &&
                          settings.paymentData &&
                          settings.paymentData.type !== 'metrob' &&
                          !isSubscriptionManaged
                        "
                      >
                        <v-col>
                          <h3>Renovación de su plan</h3>
                          <p class="mb-1">
                            La renovación automática evita que pierda pedidos
                            por olvidar renovar su plan
                          </p>
                          <v-checkbox
                            :label="`Renovar automáticamente con la tarjeta terminada en ${settings.paymentData.cardLast}`"
                            class="mt-0"
                            v-model="settings.autoRenew"
                            persistent-hint
                            hint="Para cambiar el medio de pago, renueve su plan con un medio de pago diferente"
                          />
                        </v-col>
                      </v-row>
                    </template>
                  </v-col>
                  <v-col cols="12" lg="6" v-if="editingBranch">
                    <!--<v-card max-width="500" outlined dense>
                      <v-card-text>
                        <h4>Mostrar en la app</h4>
                        <v-row>
                          <v-col cols="6">
                            <span>Recursos</span>
                            <div class="d-flex align-center">
                              <v-icon>mdi-map-marker</v-icon>
                              <v-icon>mdi-clock-time-four-outline</v-icon>
                              <v-icon>phone</v-icon>
                              <v-checkbox></v-checkbox>
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <span>Compartir</span>
                            <div class="d-flex align-center">
                              <v-icon>share</v-icon>
                              <v-checkbox></v-checkbox>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>-->
                    <template v-if="!onlyBranch && multipleBranches">
                      <h3>Información opcional</h3>
                      <p class="ma-4">
                        Edite esta información en
                        <v-btn
                          class="ml-1"
                          rounded
                          color="info"
                          :to="`/${restaurant.stringId}/branches`"
                          >Sucursales</v-btn
                        >
                      </p>
                    </template>
                    <template v-else-if="!multipleBranches">
                      <h4>Información opcional</h4>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-textarea
                            class="input--small-label"
                            rows="2"
                            outlined
                            hide-details
                            dense
                            label="Notas importantes"
                            v-model="editingBranch.notes"
                            placeholder="Notas importantes es un mensaje que se muestra al ingresar al menú"
                            value=""
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-if="!onlyBranch && multipleBranches">
                      <h3>Ubicación</h3>
                      <p class="ma-4">
                        Edite esta información en
                        <v-btn
                          class="ml-1"
                          rounded
                          color="info"
                          :to="`/${restaurant.stringId}/branches`"
                          >Sucursales</v-btn
                        >
                      </p>
                    </template>
                    <template v-else>
                      <template v-if="onlyBranch">
                        <h4>Nombre de la sucursal</h4>
                        <v-row>
                          <v-col cols="12" lg="6">
                            <v-text-field
                              :label="$t('name')"
                              persistent-hint
                              v-model="editingBranch.name"
                              hint="Por ejemplo, el nombre del barrio o localidad donde se encuentra ubicada"
                              :rules="$rule('required')"
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </template>
                      <h4>Ubicación</h4>
                      <v-row>
                        <v-col cols="12" lg="6">
                          <template v-if="!usesLocation">
                            <v-text-field
                              :label="$t('provinceOrState')"
                              hide-details
                              v-model="editingBranch.province"
                              :rules="$rule('required')"
                              outlined
                              dense
                            ></v-text-field>
                          </template>
                          <template v-else>
                            <v-select
                              :label="$t('provinceOrState')"
                              hide-details
                              v-model="province"
                              :items="provinces || []"
                              :loading="provinces === null"
                              outlined
                              :rules="$rule('required')"
                              item-text="name"
                              return-object
                              dense
                            ></v-select>
                          </template>
                        </v-col>
                        <v-col cols="12" lg="6">
                          <template v-if="!usesLocation">
                            <v-text-field
                              :label="$t('city')"
                              hide-details
                              v-model="editingBranch.city"
                              :rules="$rule('required')"
                              outlined
                              dense
                            ></v-text-field>
                          </template>
                          <template v-else>
                            <v-select
                              :label="$t('city')"
                              hide-details
                              v-model="city"
                              :items="cities || []"
                              :loading="cities === null"
                              :disabled="cities && cities.length === 0"
                              clearable
                              outlined
                              item-text="name"
                              return-object
                              dense
                            ></v-select>
                          </template>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" lg="6">
                          <!--<v-text-field label="Dirección"
                                        hide-details
                                        v-model="editingBranch.address" outlined dense></v-text-field>-->
                          <gmap-autocomplete
                            class="introInput"
                            :fields="['name', 'geometry.location']"
                            @place_changed="onPlaceChanged"
                          >
                            <template v-slot:input="slotProps">
                              <v-text-field
                                outlined
                                dense
                                :placeholder="$t('address')"
                                :rules="$rule('required')"
                                hide-details
                                v-model="editingBranch.address"
                                ref="input"
                                v-on:listeners="slotProps.listeners"
                                v-on:attrs="slotProps.attrs"
                              >
                              </v-text-field>
                            </template>
                          </gmap-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <div
                            style="
                              height: 350px;
                              width: 100%;
                              position: relative;
                            "
                          >
                            <l-map
                              ref="myMap"
                              :zoom="15"
                              :center="mapCenter"
                              @click="onMapClick"
                            >
                              <l-tile-layer
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                              />
                              <l-marker :lat-lng="mapCenter" />
                            </l-map>
                            <v-btn
                              color="info"
                              small
                              class="manual-position"
                              v-if="!manualPositioning"
                              @click="manualPositioning = true"
                              depressed
                              ><v-icon small class="mr-1"
                                >mdi-gesture-tap</v-icon
                              >Ubicar manualmente</v-btn
                            >
                            <v-btn
                              color="white"
                              small
                              class="manual-position"
                              v-else
                              @click="manualPositioning = false"
                              depressed
                              ><v-icon small class="mr-1">mdi-close</v-icon
                              >Cancelar</v-btn
                            >
                            <span
                              class="manual-position-note"
                              v-if="manualPositioning"
                              >Haga click donde quiera poner el marcador</span
                            >
                          </div>
                          <!--<gmap-map
                              ref="mapRef"
                              class="map-container"
                              :zoom="15"
                              :center="mapCenter">
                            <gmap-marker :position="mapCenter"></gmap-marker>
                          </gmap-map>-->
                        </v-col>
                      </v-row>
                    </template>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="6"
                    v-if="onlyBranch"
                    class="order-first order-lg-last"
                  >
                    <h4>Información opcional</h4>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-textarea
                          class="input--small-label"
                          rows="2"
                          outlined
                          hide-details
                          dense
                          label="Notas importantes"
                          v-model="editingBranch.notes"
                          placeholder="Notas importantes es un mensaje que se muestra al ingresar al menú"
                          value=""
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    
                    <!-- Danger zone eliminar sucursal -->
                    <v-divider class="my-2"></v-divider>  
                    <SettingsV2BranchDangerZone
                      :branch="editingBranch"
                    />
                  </v-col>
                </v-row>
                <div
                  class="actions text-center"
                  style="display: flex; justify-content: center"
                >
                  <!--<v-btn color="error" @click="deleteStore" class="mr-3"
                    >Eliminar tienda</v-btn
                  >-->
                  <v-btn
                    color="primary"
                    @click="save"
                    :disabled="
                      loading ||
                      !basicValid ||
                      !infoValid ||
                      (effectiveTier > 0 && !ordersValid)
                    "
                    >{{ $t('save') }}</v-btn
                  >
                </div>
              </v-form @submit.prevent>
            </v-tab-item>
            <v-tab-item eager class="additional-info" value="info">
              <v-form @submit.prevent v-model="infoValid" ref="infoForm">
                <template v-if="!onlyBranch && multipleBranches">
                  <p class="ma-4">
                    Edite esta información en
                    <v-btn
                      class="ml-1"
                      rounded
                      color="info"
                      :to="`/${restaurant.stringId}/branches`"
                      >Sucursales</v-btn
                    >
                  </p>
                </template>
                <template v-else-if="editingBranch">
                  <v-row class="mt-2">
                    <v-col cols="12" lg="6" class="py-0">
                       <div class="section-title">
                        <v-icon>mdi-information</v-icon>
                        <h4>Información básica</h4>
                      </div>
                      <v-row>
                        <v-col cols="12">
                      <v-textarea
                        class="input--small-label mt-2"
                        rows="3"
                        outlined
                        dense
                        label="Descripción"
                        placeholder="Breve descripción del restaurant"
                        v-model="editingBranch.bio"
                        :rules="$rule('max140|linesmax3')"
                      />
                      </v-col>
                      </v-row>  
                      <div class="section-title">
                        <v-icon>mdi-card-account-phone</v-icon>
                        <h4>Datos de contacto</h4>
                      </div>
                      <v-row>
                        <v-col cols="6">
                          <v-checkbox class="mt-0"
                            :label="$t('storeSettings.showTelNumber')"
                            hide-details
                            :input-value="editingBranch.tel !== null"
                            @change="
                              editingBranch.tel === null
                                ? (editingBranch.tel = '')
                                : (editingBranch.tel = null)
                            "
                          />
                          <v-text-field
                            :label="$t('telephone')"
                            class="mt-2"
                            v-if="editingBranch.tel !== null"
                            v-model="editingBranch.tel"
                            :rules="$rule('required')"
                            outlined
                            dense
                          />
                        </v-col>
                        <v-col cols="6">
                          <v-checkbox
                           class="mt-0"
                            :label="$t('storeSettings.showWhatsapp')"
                            hide-details
                            :input-value="editingBranch.whatsapp !== null"
                            @change="
                              editingBranch.whatsapp === null
                                ? (editingBranch.whatsapp = whatsAppNumber = '')
                                : (editingBranch.whatsapp = null)
                            "
                          />
                          <!--<v-text-field label="WhatsApp"
                                        class="mt-2"
                                        v-if="editingBranch.whatsapp !== null"
                                        v-model="editingBranch.whatsapp"
                                        :rules="$rule('required')"
                                        persistent-hint
                                        :hint="$t('storeSettings.whatsapp.hint')"
                                        outlined dense />-->
                          <vue-tel-input-vuetify
                            label="WhatsApp"
                            v-if="editingBranch.whatsapp !== null"
                            @input="phoneChanged"
                            :rules="$rule('required')"
                            v-model="whatsAppNumber"
                            placeholder=""
                            persistent-hint
                            hint="Con número de area"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-checkbox class="mt-0"
                            label="Mostrar email"
                            hide-details
                            :input-value="editingBranch.email !== null"
                            @change="
                              editingBranch.email === null
                                ? (editingBranch.email = '')
                                : (editingBranch.email = null)
                            "
                          />
                          <v-text-field
                            label="Email"
                            class="mt-2"
                            v-if="editingBranch.email !== null"
                            v-model="editingBranch.email"
                            :rules="$rule('required')"
                            outlined
                            dense
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <div class="section-title">
                            <v-icon>mdi-clock-time-four-outline</v-icon>
                            <h4>Redes sociales y links</h4>
                            <RestaurantTierChip :tier="1" />
                          </div>
                          <p v-if="effectiveTier === 0" class="tw-mt-1">
                            Actualice al plan <RestaurantTierChip :tier="1" /> o superior para
                            añadir redes sociales y links
                          </p>
                          <SettingsBranchLinks v-else :editing-branch="editingBranch" />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" lg="6">
                          <div class="section-title">
                            <v-icon>mdi-wifi</v-icon>
                            <h4>Otra información</h4>
                          </div>
                          <v-checkbox
                            label="Mostrar contraseña del WI-FI"
                            hide-details
                            :input-value="editingBranch.wifiPassword !== null"
                            @change="
                              editingBranch.wifiPassword === null
                                ? (editingBranch.wifiPassword = '')
                                : (editingBranch.wifiPassword = null)
                            "
                          />
                          <v-text-field
                            class="mt-2"
                            v-model="editingBranch.wifiPassword"
                            v-if="editingBranch.wifiPassword !== null"
                            label="Contraseña del WI-FI"
                            :rules="$rule('required')"
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" lg="6">
                      <div class="section-title">
                        <v-icon>mdi-clock-time-four-outline</v-icon>
                        <h4>Horarios</h4>
                      </div>
                      <v-checkbox
                        :label="$t('storeSettings.showHours')"
                        v-model="editingBranch.displayHours"
                      />
                      <template v-if="editingBranch.displayHours">
                        <v-row
                          v-for="day of days"
                          :key="day.val"
                          class="flex-md-nowrap"
                        >
                          <v-col cols="12" md="auto">
                            <v-checkbox
                              :label="$t(day.name)"
                              :input-value="
                                hourRangesByDay.hasOwnProperty(day.val)
                              "
                              @change="
                                !hourRangesByDay[day.val]
                                  ? addRange(day.val)
                                  : clearRanges(day.val)
                              "
                              class="mt-0"
                              style="min-width: 100px"
                              hide-details
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="auto"
                            class="flex-fill flex-nowrap"
                          >
                            <div
                              class="d-flex flex-row align-center"
                              v-for="(range, index) of hourRangesByDay[day.val]"
                              :key="index"
                            >
                              <v-range-slider
                                class="d-flex flex-column pr-5"
                                color=""
                                :value="[
                                  labelToVal[range.from],
                                  labelToVal[range.to],
                                ]"
                                @change="setRange(range, $event)"
                                min="0"
                                hide-details
                                thumb-label="always"
                                :max="timeCount"
                              >
                                <template v-slot:thumb-label="{ value }">
                                  {{ timeLabels[value].substr(0, 5) }}
                                </template>
                              </v-range-slider>
                              <v-btn
                                @click="removeRange(range)"
                                class="d-flex flex-column"
                                icon
                                color="red"
                              >
                                <v-icon>remove</v-icon>
                              </v-btn>
                              <v-btn
                                v-if="
                                  index < hourRangesByDay[day.val].length - 1
                                "
                                disabled
                                class="d-flex flex-column"
                                icon
                                style="width: 32px; height: 32px"
                                color="success"
                              >
                                <v-icon>add</v-icon>
                              </v-btn>
                              <v-btn
                                v-else
                                @click="addRange(day.val)"
                                class="d-flex flex-column"
                                fab
                                x-small
                                color="success"
                              >
                                <v-icon>add</v-icon>
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                      </template>
                    </v-col>
                  </v-row>
                  <div class="actions text-center">
                    <v-btn
                      color="primary"
                      @click="save"
                      :disabled="
                        loading ||
                        !infoValid ||
                        !basicValid ||
                        (effectiveTier > 0 && !ordersValid)
                      "
                      >{{ $t('save') }}</v-btn
                    >
                  </div>
                </template>
              </v-form @submit.prevent>
            </v-tab-item>
            <v-tab-item
              eager
              class="orders"
              value="orders"
              v-if="effectiveTier > 0"
            >
              <v-form @submit.prevent v-model="ordersValid" ref="ordersForm">
                <template v-if="!onlyBranch && multipleBranches">
                  <p class="ma-4">
                    Edite esta información en
                    <v-btn
                      class="ml-1"
                      rounded
                      color="info"
                      :to="`/${restaurant.stringId}/branches`"
                      >Sucursales</v-btn
                    >
                  </p>
                </template>
                <template v-else-if="editingBranch">
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <v-checkbox
                        v-model="editingBranch.settingUseCajas"
                        label="Usar módulo de Cajas"
                        persistent-hint
                        hint="Las Cajas le permiten llevar un control de las ventas y los pagos en efectivo"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <v-checkbox
                        v-model="usesClassicPos"
                        label="Usar Punto de Venta clásico"
                        persistent-hint
                        hint="Vuelve a la versión anterior del Punto de Venta en esta sucursal"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" class="py-0 mt-4">
                      <v-select
                        v-model="editingBranch.coversPromptMode"
                        :items="coversPromptModeOptions"
                        :label="$t('branchSettings.coversPromptMode')"
                        persistent-hint
                        :hint="$t('branchSettings.coversPromptMode.hint')"
                        outlined
                        dense
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" class="py-0 mt-4">
                      <v-select
                        v-model="editingBranch.businessDayStartHour"
                        :items="businessDayStartHourOptions"
                        :label="$t('branchSettings.businessDayStartHour')"
                        persistent-hint
                        :hint="$t('branchSettings.businessDayStartHour.hint')"
                        outlined
                        dense
                      ></v-select>
                      <p
                        v-if="editingBranch.businessDayStartHour > 0"
                        class="text-caption grey--text mt-1 mb-0"
                      >
                        {{ businessDayWindowPreview }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <v-checkbox
                        :label="$t('storeSettings.allowOrders')"
                        persistent-hint
                        :hint="$t('storeSettings.allowOrders.hint')"
                        v-model="editingBranch.allowOrders"
                      />
                    </v-col>
                  </v-row>

                  <v-row v-if="editingBranch.allowOrders">
                    <v-col cols="12" md="6">
                      <h3 class="font-weight-regular">
                        {{ $t('storeSettings.orders.modeTitle') }}
                      </h3>
                      <v-row>
                        <v-col cols="6">
                          <v-card
                            class="orders-mode"
                            :class="{
                              'orders-mode--active':
                                editingBranch.ordersMode === 'native',
                            }"
                            @click="editingBranch.ordersMode = 'native'"
                            :ripple="false"
                            :elevation="
                              editingBranch.ordersMode === 'native' ? 2 : 0
                            "
                          >
                            <v-card-title class="orders-mode__title">
                              <v-icon
                                class="pr-1"
                                v-if="editingBranch.ordersMode === 'native'"
                                color="green"
                                >mdi-check-circle</v-icon
                              >
                              <v-icon class="pr-1" v-else
                                >mdi-checkbox-blank-circle-outline</v-icon
                              >
                              <v-icon class="pr-1">mdi-silverware</v-icon>
                              QueRestó
                            </v-card-title>
                            <v-card-subtitle class="orders-mode__subtitle"
                              >Recibir los pedidos en esta
                              plataforma</v-card-subtitle
                            >
                            <v-card-text>
                              <ul class="orders-mode__features">
                                <li>
                                  Vea los pedidos desde cualquier dispositivo
                                </li>
                                <li>
                                  Actualice el estado de los pedidos desde la
                                  pantalla Tiempo Real
                                </li>
                                <li>
                                  Reciba notificaciones con sonido cada vez que
                                  alguien hace un pedido o pide la cuenta
                                </li>
                                <li>
                                  Consulte pedidos pasados desde la pantalla
                                  Pedidos
                                </li>
                              </ul>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="6">
                          <v-card
                            class="orders-mode"
                            :class="{
                              'orders-mode--active':
                                editingBranch.ordersMode === 'wa',
                            }"
                            @click="editingBranch.ordersMode = 'wa'"
                            :ripple="false"
                            :elevation="
                              editingBranch.ordersMode === 'wa' ? 2 : 0
                            "
                          >
                            <v-card-title class="orders-mode__title">
                              <v-icon
                                class="pr-1"
                                v-if="editingBranch.ordersMode === 'wa'"
                                color="green"
                                >mdi-check-circle</v-icon
                              >
                              <v-icon class="pr-1" v-else
                                >mdi-checkbox-blank-circle-outline</v-icon
                              >
                              <v-icon class="pr-1">mdi-whatsapp</v-icon>
                              WhatsApp
                            </v-card-title>
                            <v-card-subtitle class="orders-mode__subtitle"
                              >Recibir los pedidos por WhatsApp</v-card-subtitle
                            >
                            <v-card-text>
                              <ul class="orders-mode__features">
                                <li>
                                  Reciba los pedidos y llamados directamente del
                                  cliente en el WhatsApp que elija
                                </li>
                                <li>
                                  Los usuarios deben tener WhatsApp para poder
                                  hacer pedidos
                                </li>
                              </ul>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <h3>Medios de pago para pedidos móviles</h3>
                          <p class="mb-0" v-if="!editingBranch.id">
                            Guarde la sucursal para poder configurar los medios
                            de pago
                          </p>
                          <template v-else>
                            <v-row>
                              <v-col cols="4">
                                <h4>A la mesa</h4>
                                <v-switch
                                  v-model="
                                    editingBranch.tableOrdersAskPaymentMethod
                                  "
                                  class="mt-1"
                                  label="Preguntar medio de pago"
                                  persistent-hint
                                  hint="Si está desactivado, sus clientes eligen cómo pagar recién al momento de pagar."
                                ></v-switch>
                                <PaymentMethodsToggles
                                  v-if="
                                    editingBranch.tableOrdersAskPaymentMethod
                                  "
                                  :editing-branch="editingBranch"
                                  :restaurant="restaurant"
                                  :payment-method-enabled="paymentMethodEnabled"
                                  :toggle-payment-method="togglePaymentMethod"
                                  type="seat"
                                  :payment-method="
                                    editingBranch.paymentMethodsA
                                  "
                                  :branch-variables="branchVariables"
                                />
                                <template v-else>
                                  <p class="text--secondary caption mt-3 mb-0">
                                    Sus clientes no eligen medio de pago al
                                    pedir a la mesa.
                                  </p>
                                  <v-switch
                                    v-if="
                                      restaurant.country === 'AR' &&
                                      editingBranch.ordersMode !== 'wa'
                                    "
                                    class="mt-2"
                                    label="MercadoPago"
                                    :input-value="false"
                                    hint="Al activarlo, sus clientes eligen el medio de pago al pedir."
                                    persistent-hint
                                    dense
                                    @change="enableMercadoPagoForTableOrders"
                                  />
                                </template>
                              </v-col>
                              <v-col cols="4">
                                <h4>Take away</h4>
                                <PaymentMethodsToggles
                                  :editing-branch="editingBranch"
                                  :restaurant="restaurant"
                                  :payment-method-enabled="paymentMethodEnabled"
                                  :toggle-payment-method="togglePaymentMethod"
                                  type="away"
                                  :payment-method="
                                    editingBranch.paymentMethodsB
                                  "
                                  :branch-variables="branchVariables"
                                />
                              </v-col>
                              <v-col cols="4">
                                <h4>Delivery</h4>
                                <PaymentMethodsToggles
                                  :editing-branch="editingBranch"
                                  :restaurant="restaurant"
                                  :payment-method-enabled="paymentMethodEnabled"
                                  :toggle-payment-method="togglePaymentMethod"
                                  type="delivery"
                                  :payment-method="
                                    editingBranch.paymentMethodsC
                                  "
                                  :branch-variables="branchVariables"
                                />
                              </v-col>
                            </v-row>
                            <v-row v-if="mercadoPagoEnabled">
                              <v-col cols="12">
                                <h4>Configuración de MercadoPago</h4>
                                <div v-if="!paymentsData" class="mt-2">
                                  <v-skeleton-loader type="sentences" />
                                </div>
                                <div v-else class="text-center pa-4">
                                  <v-btn
                                    v-if="!paymentsData.mpData"
                                    @click="linkMP"
                                    color="primary"
                                    rounded
                                    depressed
                                    :loading="linkingPaymentMethod"
                                    >Vincular MercadoPago</v-btn
                                  >
                                  <v-btn
                                    v-else
                                    @click="unlinkMP"
                                    color="red"
                                    dark
                                    rounded
                                    depressed
                                    :loading="linkingPaymentMethod"
                                  >
                                    <v-icon class="mr-2">mdi-close</v-icon>
                                    Desvincular MercadoPago
                                  </v-btn>
                                </div>
                                <p class="mb-0 grey--text font-size-9e">
                                  Los pagos a través de MercadoPago tienen un 1%
                                  de comisión destinado a mantener la
                                  plataforma.
                                </p>
                              </v-col>
                            </v-row>
                            <div class="custom-fields mt-2">
                              <h3>Campos Personalizados</h3>
                              <p class="grey--text font-size-9e mb-1">
                                Los campos personalizados son información
                                adicional que puede solicitar al cliente al
                                momento de hacer el pedido. <br />Por ejemplo:
                                DNI, número de habitación, etc.<br />
                                <strong
                                  >No agregue campos que la plataforma ya
                                  solicita por defecto</strong
                                >, por ejemplo telefono, dirección, nombre, etc.
                              </p>
                              <template v-if="!customFields">
                                <v-skeleton-loader type="paragraph" />
                              </template>
                              <template v-else>
                                <v-row
                                  align="center"
                                  v-for="field of activeCustomFields"
                                  :key="field.id || field.createdAt"
                                >
                                  <v-col cols="12" sm="4" md="4">
                                    <v-text-field
                                      class="mt-1"
                                      label="Título"
                                      placeholder="Ej: DNI"
                                      hide-details
                                      outlined
                                      dense
                                      :rules="$rule('required')"
                                      v-model="field.title"
                                    />
                                  </v-col>
                                  <v-col cols="12" sm="2" md="2">
                                    <v-checkbox
                                      class="checkbox--label-bottom mt-0"
                                      label="Obligatorio"
                                      hide-details
                                      v-model="field.mandatory"
                                      @change="changedCustomFields = true"
                                    />
                                  </v-col>
                                  <v-col cols="12" sm="4" md="4">
                                    <div class="order-types">
                                      <!--<h3 class="font-weight-regular">solicitar en</h3>-->
                                      <div
                                        class="d-flex flex-row align-center justify-lg-space-between"
                                      >
                                        <v-checkbox
                                          class="checkbox--label-bottom mt-0"
                                          label="Salón"
                                          hide-details
                                          :input-value="
                                            field.orderTypes.indexOf('s') > -1
                                          "
                                          @change="
                                            customFieldToggleType(field, 's')
                                          "
                                        />
                                        <v-checkbox
                                          class="checkbox--label-bottom mt-0"
                                          label="Take Away"
                                          hide-details
                                          :input-value="
                                            field.orderTypes.indexOf('t') > -1
                                          "
                                          @change="
                                            customFieldToggleType(field, 't')
                                          "
                                        />
                                        <v-checkbox
                                          class="checkbox--label-bottom mt-0"
                                          label="Delivery"
                                          hide-details
                                          :input-value="
                                            field.orderTypes.indexOf('d') > -1
                                          "
                                          @change="
                                            customFieldToggleType(field, 'd')
                                          "
                                        />
                                      </div>
                                    </div>
                                  </v-col>
                                  <v-col cols="12" sm="1" md="1">
                                    <v-btn
                                      color="error"
                                      fab
                                      dark
                                      small
                                      elevation="3"
                                      class=""
                                      @click="removeCustomField(field)"
                                    >
                                      <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                  </v-col>
                                </v-row>
                                <div class="text-center mt-2">
                                  <v-btn
                                    color="green"
                                    rounded
                                    dark
                                    small
                                    elevation="3"
                                    class=""
                                    @click="addCustomField"
                                  >
                                    <v-icon class="mr-1">mdi-plus</v-icon>
                                    Agregar campo
                                  </v-btn>
                                </div>
                              </template>
                            </div>
                          </template>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="6">
                      <h3 class="font-weight-regular">
                        {{ $t('storeSettings.orders.title') }}
                      </h3>
                      <!--<v-text-field :label="$t('storeSettings.orders.whatsapp')"
                                    class="mt-4 mb-n2"
                                    v-if="editingBranch.ordersMode === 'wa'"
                                    v-model="editingBranch.ordersWhatsapp"
                                    :rules="$rule('required')"
                                    persistent-hint
                                    :hint="$t('storeSettings.whatsapp.hint')"
                                    outlined dense />-->
                      <div v-if="editingBranch.ordersMode === 'wa'">
                        <h4>{{ $t('storeSettings.orders.whatsapp') }}</h4>
                        <v-checkbox
                          :input-value="singleOrdersWhatsApp"
                          class="mt-0"
                          label="Mismo WhatsApp para todo tipo de pedidos"
                          @click="toggleSingleOrdersWhatsApp"
                          hide-details
                        ></v-checkbox>
                        <v-row>
                          <v-col cols="4">
                            <h4
                              class="font-weight-regular"
                              v-if="!singleOrdersWhatsApp"
                            >
                              A la mesa
                            </h4>
                            <vue-tel-input-vuetify
                              class="mt-0 mb-n2"
                              label="Número de WhatsApp"
                              @input="ordersWhatsappChanged"
                              :rules="$rule('required')"
                              v-model="ordersWhatsAppNumber"
                              placeholder=""
                              persistent-hint
                              hint="Con número de area"
                            />
                          </v-col>
                          <template v-if="!singleOrdersWhatsApp">
                            <v-col cols="4">
                              <h4 class="font-weight-regular">Take away</h4>
                              <vue-tel-input-vuetify
                                class="mt-0 mb-n2"
                                label="Número de WhatsApp"
                                @input="ordersWhatsappBChanged"
                                :rules="$rule('required')"
                                v-model="ordersWhatsAppNumberB"
                                placeholder=""
                                persistent-hint
                                hint="Con número de area"
                              />
                            </v-col>
                            <v-col cols="4">
                              <h4 class="font-weight-regular">Delivery</h4>
                              <vue-tel-input-vuetify
                                class="mt-0 mb-n2"
                                label="Número de WhatsApp"
                                @input="ordersWhatsappCChanged"
                                :rules="$rule('required')"
                                v-model="ordersWhatsAppNumberC"
                                placeholder=""
                                persistent-hint
                                hint="Con número de area"
                              />
                            </v-col>
                          </template>
                        </v-row>
                      </div>
                      <v-checkbox
                        v-model="editingBranch.tableOrders"
                        :label="$t('storeSettings.allowTableOrders')"
                        persistent-hint
                        :hint="$t('storeSettings.allowTableOrders.hint')"
                      ></v-checkbox>
                      <div
                        v-if="shouldShowPostOrderSection('table')"
                        class="pl-6 mt-1 mb-2"
                      >
                        <SettingsBranchPostOrderSection
                          order-type-key="table"
                          :editing-branch="editingBranch"
                          :error-message="postOrderValidationErrors.table"
                          @change="onPostOrderSettingsChanged('table')"
                        />
                      </div>
                      <v-checkbox
                        v-model="editingBranch.takeAway"
                        :label="$t('storeSettings.allowTakeAway')"
                        hide-details
                      ></v-checkbox>
                      <v-radio-group
                        class="pl-6 mt-2"
                        hide-details
                        v-model="editingBranch.takeAwayOnlyQr"
                        v-if="editingBranch.takeAway"
                      >
                        <!--<v-radio label="Solo escaneando códigos QR para take away o genéricos"
                                 value= false />-->
                        <v-radio
                          :label="$t('storeSettings.takeAwayOnlyQr.yes')"
                          :value="true"
                        />
                        <v-radio
                          :label="$t('storeSettings.takeAwayOnlyQr.no')"
                          :value="false"
                        />
                      </v-radio-group>
                      <div
                        v-if="shouldShowPostOrderSection('takeAway')"
                        class="pl-6 mt-1 mb-2"
                      >
                        <SettingsBranchPostOrderSection
                          order-type-key="takeAway"
                          :editing-branch="editingBranch"
                          :error-message="postOrderValidationErrors.takeAway"
                          @change="onPostOrderSettingsChanged('takeAway')"
                        />
                      </div>
                      <v-checkbox
                        v-model="editingBranch.delivery"
                        :label="$t('storeSettings.allowDelivery')"
                        hide-details
                      ></v-checkbox>
                      <div v-if="editingBranch.delivery" class="pl-6">
                        <v-checkbox
                          :input-value="editingBranch.deliveryMin !== null"
                          label="Monto mínimo para delivery"
                          hint="Active esta opción para exigir un monto mínimo en pedidos de delivery"
                          persistent-hint
                          @change="toggleDeliveryMin"
                        ></v-checkbox>
                        <v-text-field
                          label="Monto mínimo"
                          class="mt-3"
                          v-if="editingBranch.deliveryMin !== null"
                          style="width: 110px"
                          v-model="editingBranch.deliveryMin"
                          background-color="#fff"
                          :prefix="`${currency.symbol}`"
                          type="number"
                          hide-details
                          :rules="$rule('required|allnumber')"
                          outlined
                          dense
                        />
                        <v-checkbox
                          v-model="editingBranch.requireFullAddress"
                          label="Exigir al cliente ubicar su dirección en el mapa"
                          hint="Esta opción permite restringir los envíos por zona pero puede ser dificultosa para algunos usuarios."
                          persistent-hint
                        ></v-checkbox>
                        <h4 class="font-weight-regular mt-2">Costo de envío</h4>
                        <div class="pl-6">
                          <v-radio-group
                            class="mt-0 mb-2"
                            v-model="deliveryCostMode"
                            hide-details
                          >
                            <v-radio label="Gratis" :value="0" />
                            <v-radio
                              label="Lo arreglo con el comprador"
                              :value="1"
                            />
                            <v-radio
                              label="Según zona de envío"
                              :value="3"
                              :disabled="
                                !editingBranch.requireFullAddress ||
                                !editingBranch.zonedDelivery
                              "
                            />
                            <div v-if="deliveryCostMode === 3" class="pl-6">
                              <p class="grey--text font-size-9e mb-1">
                                Ingrese 0 si el envío es gratis
                              </p>
                              <v-row
                                v-for="zone of zones"
                                :key="zone.id"
                                align="center"
                                class="mx-0"
                              >
                                <v-col
                                  cols="3"
                                  class="grey--text font-size-9e py-1"
                                >
                                  {{ zone.name }}
                                </v-col>
                                <v-col cols="9" class="py-1">
                                  <v-text-field
                                    label="Costo"
                                    style="width: 110px"
                                    v-model="zone.cost"
                                    background-color="#fff"
                                    :prefix="`${currency.symbol}`"
                                    type="number"
                                    hide-details
                                    @change="changedZones = true"
                                    :rules="$rule('required|allnumber')"
                                    outlined
                                    dense
                                  />
                                </v-col>
                              </v-row>
                            </div>
                            <v-radio label="Costo fijo" :value="2" />
                          </v-radio-group>
                          <v-text-field
                            label="Costo"
                            v-if="deliveryCostMode === 2"
                            style="width: 110px"
                            v-model="editingBranch.deliveryCost"
                            background-color="#fff"
                            :prefix="`${currency.symbol}`"
                            type="number"
                            hide-details
                            :rules="$rule('required|allnumber')"
                            outlined
                            dense
                          />
                        </div>
                        <h4 class="font-weight-regular mt-2">Zonas de envío</h4>
                        <v-radio-group
                          class="mt-0 mb-2"
                          v-model="editingBranch.zonedDelivery"
                          hide-details
                          :disabled="!editingBranch.requireFullAddress"
                        >
                          <v-radio
                            label="Envíos sin restricción de distancia"
                            :value="false"
                          />
                          <v-radio
                            label="Limitar envíos a una o mas zonas determinadas"
                            :value="true"
                          />
                        </v-radio-group>
                        <div
                          class="zones-container"
                          v-if="editingBranch.zonedDelivery"
                        >
                          <h4 class="font-weight-regular mt-n1 font-size-9e">
                            Zonas
                          </h4>
                          <p class="mb-1 grey--text font-size-9e">
                            Las zonas pueden superponerse. Si un punto de envío
                            queda dentro de dos zonas, se elegirá la más
                            conveniente o la que tenga costo de envío menor.
                          </p>
                          <div class="inner children-inline d-flex flex-wrap">
                            <div
                              class="zone"
                              v-for="zone of zones"
                              :key="zone.id"
                            >
                              <span class="name">{{ zone.name }}</span>
                              <v-btn
                                icon
                                color="#ffe0c8"
                                x-small
                                @click="editZone(zone)"
                                ><v-icon small>mdi-pencil</v-icon></v-btn
                              >
                            </div>
                            <v-btn class="add-new" icon @click="createNewZone">
                              <v-icon>add</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="shouldShowPostOrderSection('delivery')"
                        class="pl-6 mt-1 mb-2"
                      >
                        <SettingsBranchPostOrderSection
                          order-type-key="delivery"
                          :editing-branch="editingBranch"
                          :error-message="postOrderValidationErrors.delivery"
                          @change="onPostOrderSettingsChanged('delivery')"
                        />
                      </div>
                      <v-checkbox
                        v-model="editingBranch.anonymousOrders"
                        :label="$t('storeSettings.allowAnonymousOrders')"
                        persistent-hint
                        :hint="$t('storeSettings.allowAnonymousOrders.hint')"
                      ></v-checkbox>
                    </v-col>
                  </v-row>

                  <div class="actions text-center">
                    <v-btn color="primary" @click="save" :disabled="loading">{{
                      $t('save')
                    }}</v-btn>
                  </div>
                </template>
              </v-form @submit.prevent>
            </v-tab-item>
            <v-tab-item value="plan" v-if="!onlyBranch">
              <RestaurantBillingPlans
                :restaurant="restaurant"
                :currency="currency"
                :user="user"
              ></RestaurantBillingPlans>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-container>
  </v-layout>
</template>

<script lang="ts">
  import {gmapApi} from 'gmap-vue/dist/gmap-vue';
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
  import { IRestaurant } from '../../interfaces/IRestaurant';
  import SingleImageUploader from '../SingleImageUploader.vue';
  import { Globals } from '../../modules/Globals';
  import { vueData } from '../../VueData';
  import { AlertType } from '../../interfaces/IAlert';
  import RestaurantsService, {
    IRestaurantSettings,
  } from '../../api/services/restaurants.service';
  import { IBranch } from '../../interfaces/IBranch';
  import BranchesService from '../../api/services/branches.service';
  import { debounce } from '../../utils';
  import RestaurantBillingPlans from '../billing/RestaurantBillingPlans.vue';
  import { ICurrency } from '../../interfaces/ICurrency';
  import { IHourRange } from '../../interfaces/IHourRange';
  import { OrderMode, OrderType } from '../../enums/OrderEnums';
  import { ILocation } from '../../interfaces/ILocation';
  import LocationsService from '../../api/services/locations.service';
  import { ISocialNetworks } from '../../interfaces/ISocialNetworks';
  import { PaymentMethod } from '../../enums/PaymentMethod';
  import PaymentMethodsToggles from './PaymentMethodsToggles.vue';
  import { IBranchPaymentsData } from './IBranchPaymentsData';
  import { IDeliveryZone } from '../../interfaces/IDeliveryZone';
  import NewZoneModal from '../modals/NewZoneModal.vue';
  import DeliveryZonesService from '../../api/services/delivery-zones.service';
  import { IUser } from '../../interfaces/IUser';
  import ICustomField from '../../interfaces/ICustomField';
  import CustomFieldsService from '../../api/services/custom-fields.service';
  import InputModal from '../modals/InputModal.vue';
  import RestaurantVariablesService from '../../api/services/restaurant-variables.service';
  import RestaurantVariableCategory from '../../enums/RestaurantVariableCategory';
  import { showScrollableModal } from '../../lib/modals';
  import IVariable from '../../interfaces/IVariable';
import SettingsBranchLinks from './settings/branch/SettingsBranchLinks.vue';
import SettingsBranchPostOrderSection from './settings/branch/SettingsBranchPostOrderSection.vue';
import RestaurantTierChip from '../partials/RestaurantTierChip.vue';
import SettingsV2BranchDangerZone from '../settings/v2/branch/SettingsV2BranchDangerZone.vue';
import { getTopLevelDomain } from '@/utils/domain.utils';
import { getEffectiveTier, isPlanExpired } from '@/utils/billing-entitlements.utils';
import { refreshStoreLook } from '@/composition/design/store-look';
import {
  lookInputsChanged,
  restaurantAfterUpdate,
} from '@/domain/restaurant/restaurant-update';
import { useRestaurantStore } from '@/stores/restaurant.store';
import { PostOrderDisplayMode } from '@/enums/PostOrderDisplayMode';
import {
  BRANCH_POST_ORDER_SECTION_KEYS,
  getBranchPostOrderSectionConfig,
  modeRequiresCustomMessage,
  normalizePostOrderCustomMessage,
  POST_ORDER_CUSTOM_MESSAGE_MAX_LENGTH,
  shouldShowBranchPostOrderSection,
  TBranchPostOrderSectionKey,
} from './settings/branch/post-order-display.utils';

  @Component({
    components: { PaymentMethodsToggles, RestaurantBillingPlans, SingleImageUploader, SettingsBranchLinks, SettingsBranchPostOrderSection, RestaurantTierChip, SettingsV2BranchDangerZone },
  })
  export default class RestaurantSettings extends Vue {
    $refs: {
      infoForm: any;
      ordersForm: any;
      myMap: any;
    };
    @Prop({ default: false }) onlyBranch: boolean;
    @Prop() restaurant: IRestaurant;
    @Prop() currency: ICurrency;
    @Prop() branch: IBranch;
    @Prop() user: IUser;

    get effectiveTier(): number {
      return getEffectiveTier(this.restaurant);
    }

    get isPlanExpired(): boolean {
      return isPlanExpired(this.restaurant?.planExpiresAt);
    }

    get isSubscriptionManaged(): boolean {
      if (this.onlyBranch) return false;

      const status = this.restaurantStore.billingSubscriptionStatus ?? 'idle';
      if (status === 'error') return false;
      if (status !== 'loaded') return true;

      const summary = this.restaurantStore.billingSubscriptionSummary ?? null;
      if (!summary) return true;
      return summary.status !== 'NONE';
    }

    settings: IRestaurantSettings = null;
    restaurantStore = useRestaurantStore();
    restaurantsService = new RestaurantsService();
    deliveryZonesService = new DeliveryZonesService();
    branchesService = new BranchesService();
    locationsService = new LocationsService();
    customFieldsService = new CustomFieldsService();
    editingRestaurant: IRestaurant = null;
    editingBranch: IBranch = null;
    socialNetworks: ISocialNetworks = null;
    countries = Globals.countries;
    currencies = Globals.currencies;
    days = Globals.days;
    loading = false;
    place = null;
    autoCompleteService = null;
    placesService = null;
    searchAddress: (address) => any;
    basicValid = false;
    infoValid = false;
    ordersValid = false;
    whatsAppNumber = null;
    ordersWhatsAppNumber = null;
    ordersWhatsAppNumberB = null;
    ordersWhatsAppNumberC = null;
    postOrderValidationErrors: Record<TBranchPostOrderSectionKey, string | null> = {
      table: null,
      takeAway: null,
      delivery: null,
    };

    customFields: ICustomField[] = null;
    changedCustomFields = false;

    provinces: ILocation[] = null;
    cities: ILocation[] = null;
    province: ILocation = null;
    city: ILocation = null;

    zones: IDeliveryZone[] = null;
    changedZones = false;

    hourRanges: IHourRange[] = [];
    minuteInterval = 15;
    timeCount = 0;
    timeLabels = [];
    labelToVal = {};

    paymentsData: IBranchPaymentsData = null;
    changedTimes = false;

    linkingPaymentMethod = false;

    manualPositioning = false;

    restaurantVariables: Array<IVariable<any>> = [];
    branchVariables: Array<IVariable<any>> = [];

    async created() {
      window.addEventListener('message', this.listenMpCode.bind(this));

      if (!this.onlyBranch) this.editingRestaurant = { ...this.restaurant };

      await this.loadProvinces();
      await this.loadCities();
      await this.loadSettings();
      await this.loadRestaurantVariables();

      this.initBranch();

      this.setUpTimes();

      this.searchAddress = debounce((address) => {
        // Places services only exist once the Google Maps script loads (see
        // gmapChanged); typing before that must not crash the page.
        if (!this.autoCompleteService || !this.placesService) return;
        this.autoCompleteService.getQueryPredictions(
          { input: address },
          (predictions, status) => {
            if (!predictions || !predictions.length) return;

            const info = predictions[0];
            this.placesService.getDetails(
              { placeId: info.place_id, fields: ['geometry.location'] },
              (place) => {
                this.editingBranch.lat = place.geometry.location.lat();
                this.editingBranch.lon = place.geometry.location.lng();
              }
            );
          }
        );
      }, 500);
    }

    async loadRestaurantVariables() {
      this.restaurantVariables = await RestaurantVariablesService.get({
        restaurantId: this.restaurant.id,
      });
    }

    async loadBranchVariables() {
      this.branchVariables = await RestaurantVariablesService.get({
        restaurantId: this.restaurant.id,
        branchId: this.editingBranch.id,
      });
    }

    async loadSettings() {
      this.settings = await this.restaurantsService.getSettings(
        this.restaurant.id
      );
    }

    async saveSettings() {
      if (!this.settings) return;

      const payload = { ...this.settings };
      const billingStatus = this.restaurantStore.billingSubscriptionStatus ?? 'idle';
      const subscription = this.restaurantStore.billingSubscriptionSummary ?? null;

      // If billing subscription state is known and managed, keep legacy auto-renew disabled.
      // (Also fixes stale DB rows where auto_renew remained enabled from old flows.)
      if (billingStatus === 'loaded' && subscription && subscription.status !== 'NONE') {
        payload.autoRenew = false;
      }

      await this.restaurantsService.saveSettings(this.restaurant.id, payload);
    }

    onMapClick(event) {
      if (this.manualPositioning) {
        this.editingBranch.lat = event.latlng.lat;
        this.editingBranch.lon = event.latlng.lng;
        this.manualPositioning = false;
      }
    }

    @Watch('editingRestaurant.country')
    countryChanged(newId) {
      this.loadProvinces();
    }

    @Watch('editingBranch.ordersMode')
    ordersModeChanged(newMode) {
      if (newMode === 'wa') {
        this.editingBranch.paymentMethodsA &= ~(
          PaymentMethod.Online
        );
        this.editingBranch.paymentMethodsB &= ~(
          PaymentMethod.Online
        );
        this.editingBranch.paymentMethodsC &= ~(
          PaymentMethod.Online
        );
      }
    }

    @Watch('editingBranch.requireFullAddress')
    requireFullAddressChanged(newVal, oldVal) {
      if (!newVal) {
        this.editingBranch.zonedDelivery = false;
        if (this.deliveryCostMode === 3) this.deliveryCostMode = 2;
      }
    }

    @Watch('editingBranch.zonedDelivery')
    zonedDeliveryChanged(newVal: boolean | undefined) {
      if (newVal === false && this.editingBranch?.zonedFee) {
        // Keep delivery settings consistent: zone-based fee requires zoned delivery.
        this.editingBranch.zonedFee = false;
      }
    }

    createNewZone() {
      this.$modal.show(
        NewZoneModal,
        {
          restaurant: this.restaurant,
          branch: this.editingBranch,
        },
        {
          adaptive: true,
          height: 'auto',
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
        },
        {
          save: (zone: IDeliveryZone) => {
            this.zones.push(zone);
            this.changedZones = true;
          },
        }
      );
    }

    editZone(zone: IDeliveryZone) {
      this.$modal.show(
        NewZoneModal,
        {
          restaurant: this.restaurant,
          branch: this.editingBranch,
          zone,
        },
        {
          adaptive: true,
          height: 'auto',
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
        },
        {
          save: (z: IDeliveryZone) => {
            const index = this.zones.indexOf(zone);
            Vue.set(this.zones, index, z);
            this.changedZones = true;
          },
          delete: () => {
            const index = this.zones.indexOf(zone);
            this.zones.splice(index, 1);
            this.changedZones = true;
          },
        }
      );
    }

    get singleOrdersWhatsApp() {
      return (
        this.editingBranch &&
        this.editingBranch.ordersMode === OrderMode.WhatsApp &&
        this.editingBranch.ordersWhatsappB === null &&
        this.editingBranch.ordersWhatsappC === null
      );
    }

    paymentMethodEnabled(method: PaymentMethod, val: number) {
      return (val & method) === method;
    }

    togglePaymentMethod(method: PaymentMethod, orderType: OrderType) {
      let prop: string;
      switch (orderType) {
        case OrderType.Seat:
          prop = 'paymentMethodsA';
          break;
        case OrderType.Away:
          prop = 'paymentMethodsB';
          break;
        case OrderType.Delivery:
          prop = 'paymentMethodsC';
          break;
      }

      const currentlyEnabled = (this.editingBranch[prop] & method) === method;

      this.editingBranch[prop] ^= method;
    }

    enableMercadoPagoForTableOrders() {
      if (
        !this.paymentMethodEnabled(
          PaymentMethod.Online,
          this.editingBranch.paymentMethodsA
        )
      ) {
        this.editingBranch.paymentMethodsA |= PaymentMethod.Online;
      }
      this.editingBranch.tableOrdersAskPaymentMethod = true;
    }

    get mercadoPagoEnabled() {
      return (
        this.paymentMethodEnabled(
          PaymentMethod.Online,
          this.editingBranch.paymentMethodsA
        ) ||
        this.paymentMethodEnabled(
          PaymentMethod.Online,
          this.editingBranch.paymentMethodsB
        ) ||
        this.paymentMethodEnabled(
          PaymentMethod.Online,
          this.editingBranch.paymentMethodsC
        )
      );
    }

    linkMP() {
      const returnUrl = `https://${getTopLevelDomain()}/admin/marketplaceLink`;
      let url;
      switch (this.restaurant.country) {
        case 'AR':
          url = `https://auth.mercadopago.com.ar/authorization?client_id=6959175641483630&response_type=code&platform_id=mp&redirect_uri=${returnUrl}`;
          break;
        case 'CO':
          url = `https://auth.mercadopago.com.co/authorization?client_id=2950084059894973&response_type=code&platform_id=mp&redirect_uri=${returnUrl}`;
          break;
      }
      const page = window.open(url);
    }

    async unlinkMP() {
      try {
        this.linkingPaymentMethod = true;
        const branch = await this.branchesService.unlinkPaymentMethod(
          this.editingBranch,
          PaymentMethod.Online
        );
        this.paymentsData.mpData = branch.mpData;
        this.editingBranch.paymentMethodsA = branch.paymentMethodsA;
        this.editingBranch.paymentMethodsB = branch.paymentMethodsB;
        this.editingBranch.paymentMethodsC = branch.paymentMethodsC;
        vueData.addAlert(
          'Medio de pago desvinculado exitosamente',
          AlertType.Success
        );
      } catch (e) {
        vueData.serverError(e);
      } finally {
        this.linkingPaymentMethod = false;
      }
    }

    lastLinkCode = null;
    async listenMpCode(data) {
      if (typeof data.data === 'string') {
        if (data.data.startsWith('mpCode')) {
          (data.source as Window).close();
          const code = data.data.split('|')[1].trim();
          if (!code) return;

          if (code === this.lastLinkCode) return;
          this.lastLinkCode = code;

          try {
            this.linkingPaymentMethod = true;
            const branch = await this.branchesService.linkPaymentMethod(
              this.editingBranch,
              PaymentMethod.Online,
              { code }
            );
            this.paymentsData.mpData = branch.mpData;
          } catch (e) {
            vueData.serverError(e);
          } finally {
            this.linkingPaymentMethod = false;
          }
        }
      }
    }

    beforeDestroy() {
      window.removeEventListener('message', this.listenMpCode.bind(this));
    }

    toggleSingleOrdersWhatsApp() {
      if (this.singleOrdersWhatsApp) {
        this.editingBranch.ordersWhatsappB = '';
        this.editingBranch.ordersWhatsappC = '';
      } else {
        this.editingBranch.ordersWhatsappB = this.editingBranch.ordersWhatsappC = null;
      }
    }

    async loadProvinces() {
      this.provinces = this.province = null;

      this.provinces = await this.locationsService.getProvinces(
        this.editingRestaurant?.country || this.restaurant.country
      );
    }

    async loadCities() {
      this.cities = this.city = null;

      if (this.province)
        this.cities = await this.locationsService.getCities(this.province.id);
      else this.cities = [];
    }

    phoneChanged(e, data) {
      this.editingBranch.whatsapp = data.number.e164;
    }

    ordersWhatsappChanged(e, data) {
      this.editingBranch.ordersWhatsapp = data.number.e164;
    }

    ordersWhatsappBChanged(e, data) {
      this.editingBranch.ordersWhatsappB = data.number.e164;
    }

    ordersWhatsappCChanged(e, data) {
      this.editingBranch.ordersWhatsappC = data.number.e164;
    }

    @Watch('restaurant')
    restaurantChanged(newRes) {
      if (!this.onlyBranch) this.editingRestaurant = { ...newRes };
    }

    get usesLocation() {
      return (
        this.editingBranch &&
        (this.editingBranch.locationId || !this.editingBranch.id)
      );
    }

    ensurePostOrderDisplayDefaults(branch: IBranch) {
      if (!branch) return;

      for (const key of BRANCH_POST_ORDER_SECTION_KEYS) {
        const config = getBranchPostOrderSectionConfig(key);
        branch[config.modeKey] =
          branch[config.modeKey] || PostOrderDisplayMode.Status;

        if (typeof branch[config.customMessageKey] === 'undefined') {
          branch[config.customMessageKey] = null;
        }
      }
    }

    resetPostOrderValidationErrors() {
      for (const key of BRANCH_POST_ORDER_SECTION_KEYS) {
        this.postOrderValidationErrors[key] = null;
      }
    }

    onPostOrderSettingsChanged(orderTypeKey?: TBranchPostOrderSectionKey) {
      if (!orderTypeKey) {
        this.resetPostOrderValidationErrors();
        return;
      }

      this.postOrderValidationErrors[orderTypeKey] = null;
    }

    shouldShowPostOrderSection(orderTypeKey: TBranchPostOrderSectionKey) {
      return shouldShowBranchPostOrderSection(this.editingBranch, orderTypeKey);
    }

    validatePostOrderSettings() {
      this.resetPostOrderValidationErrors();

      if (!this.editingBranch) return true;

      this.ensurePostOrderDisplayDefaults(this.editingBranch);

      for (const key of BRANCH_POST_ORDER_SECTION_KEYS) {
        const config = getBranchPostOrderSectionConfig(key);
        const normalized = normalizePostOrderCustomMessage(
          this.editingBranch[config.customMessageKey]
        );
        const normalizedLength = normalized?.length ?? 0;

        if (normalizedLength > POST_ORDER_CUSTOM_MESSAGE_MAX_LENGTH) {
          const subject = this.$t(config.subjectKey) as string;
          const message = this.$t(
            'storeSettings.postOrder.validation.messageTooLong',
            { subject, maxLength: POST_ORDER_CUSTOM_MESSAGE_MAX_LENGTH }
          ) as string;
          this.postOrderValidationErrors[key] = message;
          vueData.addAlert(message, AlertType.Error);
          return false;
        }

        this.editingBranch[config.customMessageKey] = normalized;

        if (!modeRequiresCustomMessage(this.editingBranch[config.modeKey])) {
          continue;
        }

        if (normalized) {
          continue;
        }

        const subject = this.$t(config.subjectKey) as string;
        const message = this.$t(
          'storeSettings.postOrder.validation.messageRequired',
          { subject }
        ) as string;
        this.postOrderValidationErrors[key] = message;
        vueData.addAlert(message, AlertType.Error);
        return false;
      }

      return true;
    }

    @Watch('branch')
    async branchChanged(newBr) {
      this.resetPostOrderValidationErrors();

      if (newBr) {
        this.editingBranch = { ...newBr };
        this.ensurePostOrderDisplayDefaults(this.editingBranch);
        if (newBr.whatsapp && !newBr.whatsapp.startsWith('+'))
          newBr.whatsapp = '';
        this.whatsAppNumber = newBr.whatsapp;
        if (newBr.ordersWhatsapp && !newBr.ordersWhatsapp.startsWith('+'))
          newBr.ordersWhatsapp = '';
        this.ordersWhatsAppNumber = newBr.ordersWhatsapp;
        this.ordersWhatsAppNumberB = newBr.ordersWhatsappB;
        this.ordersWhatsAppNumberC = newBr.ordersWhatsappC;
        //console.log(parsePhoneNumberFromString(newBr.whatsapp));

        if (newBr.locationId) {
          const location = newBr.location;
          if (!location.parent) {
            this.province =
              this.provinces.find((p) => p.id === location.id) || null;
          } else {
            this.province =
              this.provinces.find((p) => p.id === location.parentId) || null;
            await this.loadCities();
            this.city = this.cities.find((c) => c.id === location.id) || null;
          }
        } else {
          this.city = this.province = null;
        }

        this.paymentsData = null;
        if (this.editingBranch.id) {
          this.paymentsData = await this.branchesService.getPaymentsData(
            this.editingBranch.id
          );
          await this.loadBranchVariables();
        } else this.paymentsData = { pData: null };

        await this.loadZones();

        if (this.$refs.myMap) {
          setTimeout(() => {
            this.$refs.myMap.mapObject.invalidateSize();
          }, 10);
        }

        this.customFields = newBr.id
          ? await CustomFieldsService.getAll(this.restaurant.id, newBr.id)
          : [];
      } else {
        this.editingBranch = null;
        this.paymentsData = null;
        this.customFields = [];
      }
    }

    async loadZones() {
      if (!this.editingBranch) {
        this.zones = null;
      } else if (!this.editingBranch.id) {
        this.zones = [];
      } else {
        this.zones = await DeliveryZonesService.getByBranch(
          this.editingBranch.id
        );
      }
    }

    @Watch('province')
    provinceChanged(newProvince) {
      this.loadCities();
    }

    toggleDeliveryMin() {
      this.editingBranch.deliveryMin =
        this.editingBranch.deliveryMin === null ? 0 : null;
    }

    get deliveryCostMode() {
      if (this.editingBranch.zonedFee) return 3;

      const rawCost = this.editingBranch.deliveryCost;
      if (rawCost === null || typeof rawCost === 'undefined') return 1;

      const cost = Number(rawCost);
      if (!Number.isFinite(cost)) return 1;

      if (cost === 0) return 0;

      return 2;
    }

    set deliveryCostMode(val: number) {
      switch (val) {
        case 0:
          this.editingBranch.zonedFee = false;
          this.editingBranch.deliveryCost = 0;
          break;
        case 1:
          this.editingBranch.zonedFee = false;
          this.editingBranch.deliveryCost = null;
          break;
        case 2:
          this.editingBranch.zonedFee = false;
          if (
            this.editingBranch.deliveryCost === null ||
            typeof this.editingBranch.deliveryCost === 'undefined' ||
            !Number.isFinite(Number(this.editingBranch.deliveryCost)) ||
            Number(this.editingBranch.deliveryCost) === 0
          ) {
            this.editingBranch.deliveryCost = 1;
          }
          break;
        case 3:
          this.editingBranch.zonedFee = true;
          this.editingBranch.deliveryCost = 0;
          break;
      }
    }

    get activeCustomFields() {
      return this.customFields.filter((c) => !c.deletedAt);
    }

    addCustomField() {
      this.changedCustomFields = true;
      this.customFields.push({
        title: '',
        restaurantId: this.restaurant.id,
        branchId: this.editingBranch.id,
        mandatory: true,
        orderTypes: ['s', 't', 'd'],
        createdAt: new Date().toString(),
      });
    }

    removeCustomField(field: ICustomField) {
      this.changedCustomFields = true;
      if (field.id) Vue.set(field, 'deletedAt', new Date());
      else {
        const index = this.customFields.indexOf(field);
        this.customFields.splice(index);
      }

      //field.deletedAt = new Date();
    }

    customFieldToggleType(field: ICustomField, type: string) {
      this.changedCustomFields = true;
      const index = field.orderTypes.indexOf(type);
      if (index > -1) field.orderTypes.splice(index, 1);
      else field.orderTypes.push(type);
    }

    async initBranch() {
      if (this.branch) {
        this.branchChanged(this.branch);
      } else {
        const branchId = this.$route.params.branchId;
        let branch = null;

        if (branchId) {
          this.editingBranch = branch = await this.branchesService.getById(
            +branchId
          );
        } else {
          const country = this.countries.find(
            (value) => value.value === this.restaurant.country
          );
          this.editingBranch = branch = {
            name: null,
            email: null,
            restaurantId: this.restaurant.id,
            delivery: true,
            deliveryMin: null,
            ordersWhatsapp: null,
            ordersWhatsappB: null,
            ordersWhatsappC: null,
            whatsapp: null,
            allowOrders: true,
            anonymousOrders: false,
            ordersMode: OrderMode.Native,
            tablePostOrderDisplayMode: PostOrderDisplayMode.Status,
            tablePostOrderCustomMessageMd: null,
            takeAwayOnlyQr: false,
            takeAway: true,
            takeAwayPostOrderDisplayMode: PostOrderDisplayMode.Status,
            takeAwayPostOrderCustomMessageMd: null,
            tableOrders: true,
            // Must exist upfront so the "Preguntar medio de pago" switch is
            // reactive on the new-branch form (Vue 2 can't track added props).
            tableOrdersAskPaymentMethod: false,
            deliveryPostOrderDisplayMode: PostOrderDisplayMode.Status,
            deliveryPostOrderCustomMessageMd: null,
            address: null,
            tel: null,
            province: null,
            city: null,
            displayHours: false,
            lat: country.lat,
            lon: country.lon,
            wifiPassword: null,
            // POS V2 is the default for new branches (matches the backend).
            posV2Enabled: true,
            // Must exist upfront for the covers-prompt select to be reactive
            // (Vue 2 can't track added props); backend default is 'optional'.
            coversPromptMode: 'optional',
          } as IBranch;
        }

        this.ensurePostOrderDisplayDefaults(branch);

        /*if (branch.whatsapp && !branch.whatsapp.startsWith('+'))
        branch.whatsapp = '';
      this.whatsAppNumber = branch.whatsapp;
      if (branch.ordersWhatsapp && !branch.ordersWhatsapp.startsWith('+'))
        branch.ordersWhatsapp = '';
      this.ordersWhatsAppNumber = branch.ordersWhatsapp;
      this.ordersWhatsAppNumberB = branch.ordersWhatsappB;
      this.ordersWhatsAppNumberC = branch.ordersWhatsappC;*/
        this.branchChanged(this.editingBranch);
      }

      setTimeout(() => {
        this.onReady();
      }, 10);
    }

    onReady() {
      this.loadHours();
      this.$refs.infoForm.validate();
      // The orders tab (and its form ref) only renders for paid tiers.
      if (this.effectiveTier > 0) this.$refs.ordersForm.validate();
    }

    async loadHours() {
      this.hourRanges = this.editingBranch.id
        ? await this.branchesService.getHours(this.editingBranch.id)
        : [];
    }

    setUpTimes() {
      const subCount = 60 / this.minuteInterval;
      const count = (this.timeCount = (24 * 60) / this.minuteInterval);

      function twoDigits(val: number) {
        return ('0' + val).slice(-2);
      }

      for (let i = 0; i < 24; i++) {
        for (let j = 0; j < subCount; j++) {
          this.timeLabels.push(
            `${twoDigits(i)}:${twoDigits(j * this.minuteInterval)}:00`
          );
          this.labelToVal[
            `${twoDigits(i)}:${twoDigits(j * this.minuteInterval)}:00`
          ] = i * 4 + j;
        }
      }
      this.timeLabels.push(`23:59:00`);
      this.labelToVal[`23:59:00`] = count;
    }

    setRange(range: IHourRange, data) {
      range.from = this.timeLabels[data[0]];
      range.to = this.timeLabels[data[1]];
      this.changedTimes = true;
    }

    removeRange(range: IHourRange) {
      this.hourRanges.splice(this.hourRanges.indexOf(range), 1);
      this.changedTimes = true;
    }

    get tabIndex() {
      return this.$route.query.tab || 'basic';
    }

    set tabIndex(val) {
      let query = { ...this.$route.query };
      query.tab = val;
      this.$router.replace({ query: query });
    }

    get hourRangesByDay() {
      const rangesByDay: { [day: number]: IHourRange[] } = {};

      for (const range of this.hourRanges) {
        let ranges;
        if (!(ranges = rangesByDay[range.day]))
          ranges = rangesByDay[range.day] = [];

        ranges.push(range);
      }

      return rangesByDay;
    }

    get multipleBranches() {
      return (
        this.effectiveTier > 1 &&
        vueData.branches.filter((b) => b.active).length > 1
      );
    }

    /**
     * Inverted proxy for the "Usar Punto de Venta clásico" checkbox: POS V2
     * is the default, so checking it disables `posV2Enabled`.
     */
    get usesClassicPos(): boolean {
      return !this.editingBranch?.posV2Enabled;
    }

    set usesClassicPos(value: boolean) {
      if (this.editingBranch) this.editingBranch.posV2Enabled = !value;
    }

    get coversPromptModeOptions() {
      return [
        {
          value: 'optional',
          text: this.$t('branchSettings.coversPromptMode.optional'),
        },
        {
          value: 'required',
          text: this.$t('branchSettings.coversPromptMode.required'),
        },
        {
          value: 'off',
          text: this.$t('branchSettings.coversPromptMode.off'),
        },
      ];
    }

    get businessDayStartHourOptions() {
      const options: { value: number; text: string }[] = [
        {
          value: 0,
          text: this.$t(
            'branchSettings.businessDayStartHour.calendarOption'
          ) as string,
        },
      ];
      for (let hour = 1; hour <= 8; hour++) {
        options.push({
          value: hour,
          text: `${String(hour).padStart(2, '0')}:00`,
        });
      }
      return options;
    }

    get businessDayWindowPreview(): string {
      const hour = this.editingBranch?.businessDayStartHour ?? 0;
      const from = `${String(hour).padStart(2, '0')}:00`;
      const to = `${String((hour + 23) % 24).padStart(2, '0')}:59`;
      return this.$t('branchSettings.businessDayStartHour.preview', {
        from,
        to,
      }) as string;
    }

    addRange(day: number) {
      this.hourRanges.push({
        restaurantId: this.restaurant.id,
        branchId: this.editingBranch?.id,
        day,
        from: '08:00:00',
        to: '16:00:00',
      });
      this.changedTimes = true;
    }

    clearRanges(day: number) {
      for (let i = this.hourRanges.length; --i >= 0; ) {
        if (this.hourRanges[i].day === day) this.hourRanges.splice(i, 1);
      }
      this.changedTimes = true;
    }

    get mapCenter() {
      return {
        lat: this.editingBranch.lat,
        lng: this.editingBranch.lon,
      };
    }

    get gmap() {
      return gmapApi();
    }

    @Watch('gmap', {immediate: true})
    gmapChanged(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.autoCompleteService = new this.gmap.maps.places.AutocompleteService();
        this.placesService = new this.gmap.maps.places.PlacesService(
          document.createElement('div')
        );
      }
    }

    @Watch('restaurant.billingId')
    onExternalBillingChange(val: string) {
      if (val) {
        this.editingRestaurant.billingId = this.restaurant.billingId;
        this.editingRestaurant.billingName = this.restaurant.billingName;
      }
    }

    @Watch('editingBranch.address')
    onAddressChanged(newAddress, oldAddress) {
      console.log('address changed', newAddress, oldAddress);
      if (typeof oldAddress !== 'undefined') this.searchAddress(newAddress);
    }

    onPlaceChanged(data) {
      if (!data) return;

      this.editingBranch.address = data.name;
      this.editingBranch.lat = data.geometry.location.lat();
      this.editingBranch.lon = data.geometry.location.lng();
    }

    async save() {
      this.$refs.infoForm.validate();
      if (this.effectiveTier > 0 && !this.ordersValid)
        this.$refs.ordersForm.validate();

      if (
        !this.infoValid ||
        !this.basicValid ||
        (this.effectiveTier > 0 && !this.ordersValid)
      ) {
        vueData.addAlert(
          'Revise que no haya errores en el formulario',
          AlertType.Error
        );
        return;
      }

      if (this.effectiveTier > 0 && !this.validatePostOrderSettings()) {
        return;
      }

      if (this.onlyBranch || !this.multipleBranches) {
        if (
          // Seat methods are only required when customers are asked for one
          (this.editingBranch.tableOrdersAskPaymentMethod &&
            this.editingBranch.paymentMethodsA === 0) ||
          this.editingBranch.paymentMethodsB === 0 ||
          this.editingBranch.paymentMethodsC === 0
        ) {
          vueData.addAlert(
            'Todos los tipos de pedido deben tener medios de pago',
            AlertType.Error
          );
          return;
        }
        if (this.mercadoPagoEnabled && !this.paymentsData.mpData) {
          vueData.addAlert(
            'Si activa MercadoPago como medio de pago, debe vincular una cuenta',
            AlertType.Error
          );
          return;
        }
        // Keep delivery settings consistent: zone-based fee requires zoned delivery.
        if (!this.editingBranch.zonedDelivery && this.editingBranch.zonedFee) {
          this.editingBranch.zonedFee = false;
        }
        if (this.editingBranch.zonedDelivery && !this.zones.length) {
          vueData.addAlert(
            'Si elige envío zonificado, debe crear al menos una zona',
            AlertType.Error
          );
          return;
        }
        if (this.editingBranch.zonedFee && !this.editingBranch.zonedDelivery) {
          vueData.addAlert(
            'Si no utiliza zonas de envío, el costo de envío no puede ser por zonas',
            AlertType.Error
          );
          return;
        }
      }

      this.loading = true;

      try {
        let stringIdChanged, restaurant;
        if (!this.onlyBranch) {
          stringIdChanged =
            this.editingRestaurant.stringId != this.restaurant.stringId;
          // The answer is the bare entity: merged, so the /full-only fields
          // (branches, the storefront look…) stay for the pages that read them.
          const previous = vueData.restaurant;
          const answer = await this.restaurantsService.update(
            this.editingRestaurant
          );
          restaurant = restaurantAfterUpdate(previous, answer);
          restaurant.settings = this.settings;
          vueData.setCurrentRestaurant(restaurant);
          // A new name, logo or banner changes the look /full derives from
          // them: read in the background, the save does not wait for it.
          if (lookInputsChanged(previous, answer))
            void refreshStoreLook(answer);
          await this.saveSettings();
          vueData.setCurrentRestaurantSettings(this.settings);
        }

        if (this.onlyBranch || !this.multipleBranches) {
          if (this.usesLocation) {
            this.editingBranch.locationId = this.city?.id || this.province.id;
          }
          const branch = this.editingBranch.id
            ? await this.branchesService.update(this.editingBranch)
            : await this.branchesService.create(this.editingBranch);

          if (this.editingBranch.id) {
            const index = vueData.branches.findIndex(
              (value) => value.id === branch.id
            );
            if (index > -1) {
              Vue.set(vueData.branches, index, branch);
              if (vueData.branch.id === branch.id) {
                vueData.setCurrentBranch(branch);
              }
            }
          } else {
            vueData.branches.push(branch);
          }

          if (this.changedTimes) {
            await this.branchesService.saveHours(branch.id, this.hourRanges);
            this.changedTimes = false;
          }

          if (this.changedZones) {
            this.zones = await this.deliveryZonesService.saveByBranch(
              branch.id,
              this.zones
            );
            this.changedZones = false;
          }

          if (this.changedCustomFields) {
            this.customFields = await this.customFieldsService.saveBatch(
              this.restaurant.id,
              branch.id,
              this.customFields
            );
            this.changedCustomFields = false;
          }
        }

        vueData.addAlert(this.$tc('storeSettings.saved'), AlertType.Success);

        if (!this.onlyBranch) {
          if (stringIdChanged)
            this.$router.replace(`/${restaurant.stringId}/settings`);
        } else {
          this.$router.push(`/${this.restaurant.stringId}/branches`);
        }
      } catch (e) {
        console.error(e);
        vueData.serverError(e, this.$tc('storeSettings.errorSaving'));
      } finally {
        this.loading = false;
        this.changedTimes = false;
      }
    }

    deleteStore() {
      this.$modal.show(
        InputModal,
        {
          type: 'password',
          title: 'Eliminar tienda',
          message:
            '¿Esta seguro que desea eliminar su tienda? Para confirmar ingrese su contraseña:',
          hint:
            'Una vez que ingrese su Contraseña y acepte se eliminará la tienda',
          placeholder: 'Contraseña',
          rules: [
            (v) =>
              /^[A-Za-z0-9\.,]{1,16}$/.test(v) ||
              'Solo números, letras y mayúsculas',
          ],
        },
        {
          name: 'token',
          adaptive: true,
          height: 'auto',
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
          width: 600,
          clickToClose: false,
        },
        {
          submit: async (input: string) => {
            // try {
            //   const token = await this.partnersService.createToken(input);
            //   this.partner.tokens.push(token);
            // } catch (e) {
            //   console.error(e);
            //   vueData.serverError(e);
            // }
            // this.$modal.hide('token');
          },
        }
      );
    }
  }
</script>

<style lang="scss" scoped>
  .section-title {
    @apply tw-flex tw-items-center tw-space-x-2;
  }
</style>